import Vue from 'vue'
import Vuex from 'vuex'
import ApiClient from './js/api.js';
import VueCookies from 'vue-cookies'

Vue.use(Vuex)
Vue.use(VueCookies)

export default new Vuex.Store({
  state: {
    postParam: {},
    token: null,
    storeList: null,
    prefList: null,
    errors: [],
    initDetail: false,
    backUrl: '',  // 戻り先URLを設定
    isLogin: null,
    cartNum: 0,
    pagePointList: null,
  },
  getters: {
    getPostParam: (state) => state.postParam,
    isSetDetail: (state) => state.initDetail,
    getToken(state) {
      if (!state.token) {
        if (!VueCookies.get('__jwt_token_user')) {
          return '';
        }
        state.token = VueCookies.get('__jwt_token_user');
      }
      return state.token;
    },
    async storeList(state) {
      if (!state.storeList) {
        const api = new ApiClient();
        const result = await api.get('/tool/storelist/s');
        state.storeList = result.list;
      }

      return state.storeList;
    },
    async prefList(state) {
      if (!state.prefList) {
        const api = new ApiClient();
        const result = await api.get('/tool/prefecturelist/s');
        state.prefList = result.list;
      }

      return state.prefList;
    },
    errors(state) {
      return state.errors;
    },
    backURL(state) {
      return state.backUrl;
    },
    cartNum(state) {
      return state.cartNum;
    },
    async isLogin(state) {
      if (state.isLogin === null) {
        const api = new ApiClient();
        const check = await api.get('/member/login/check');
        state.isLogin = check.result;
      }
      return state.isLogin;
    },
    async getPagePoint(state) {
      if (state.pagePointList === null) {
        const api = new ApiClient();
        const data = await api.get('/member/point/user_pointcode');
        state.pagePointList = data.list;
      }
      return state.pagePointList;
    },
  },
  mutations: {
    initPostParam(state) {
      state.postParam = {};
    },
    token(state, token) {
      state.token = token;
      VueCookies.set('__jwt_token_user', token);
    },
    deletePostParamGroup(state, table) {
      if (table.group != null) {
        if (table.index != null) {
          state.postParam[table.group].splice(table.index, 1);
        }
      } else {
        if (table.index != null) {
          state.postParam[table.label].splice(table.index, 1);
        }
      }
    },
    deletePostParamKey(state, key) {
      delete state.postParam[key];
    },
    setDetailParam(state, table) {
      state.postParam = table.detail;
      state.initDetail = true;
    },
    setPostParam(state, table) {
      if (table.group != null) {
        if (!state.postParam[table.group]) {
          state.postParam[table.group] = [];
        }

        if (table.index != null) {
          if (!state.postParam[table.group][table.index]) {
            state.postParam[table.group][table.index] = {};
          }
          state.postParam[table.group][table.index][table.label] = table.value;
        } else {
          state.postParam[table.group][table.label] = table.value;
        }
      } else {
        if (table.index != null) {
          if (!state.postParam[table.label]) {
            state.postParam[table.label] = [];
          }
          state.postParam[table.label][table.index] = table.value;
        } else {
          state.postParam[table.label] = table.value;
        }
      }
    },
    setErrors(state, errors) {
      state.errors = errors;
    },
    setBackURL(state, url) {
      state.backUrl = url;
    },
    setLoginStatus(state, flg) {
      state.isLogin = flg;
    },
    addCartNum(state, num) {
      state.cartNum += parseInt(num, 10);
    },
    setCartNum(state, num) {
      state.cartNum = parseInt(num, 10);
    },
  },
  actions: {
    initPostParam(state) {
      state.commit('initPostParam');
    },
    setDetailParam(state, table) {
      state.commit('setDetailParam', table);
    },
    setPostParam(state, table) {
      state.commit('setPostParam', table);
    },
    deletePostParamGroup(state, table) {
      state.commit('deletePostParamGroup', table);
    },
    deletePostParamKey(state, key) {
      state.commit('deletePostParamKey', key);
    },
    token(state, data) {
      state.commit('token', data);
    },
    setErrors(state, errors) {
      state.commit('setErrors', errors);
    },
    setBackURL(state, url) {
      state.commit('setBackURL', url);
    },
    setLoginStatus(state, status) {
      state.commit('setLoginStatus', status);
    },
    addCartNum(state, num) {
      state.commit('addCartNum', num);
    },
    setCartNum(state, num) {
      state.commit('setCartNum', num);
    },
  }
})
